// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L5CQn","question":"styles_question__1nr_v","description":"styles_description__1PfC9"};